<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="toggle-container">
    <label class="toggle-wrapper" :for="id" :class="{ 'active-border': isChanging }">
      <input
        type="checkbox"
        :id="id"
        :checked="modelValue"
        :disabled="disabled"
        class="toggle"
        :aria-describedby="`${id}-help`"
        :class="{ 'p-invalid': validation?.$error }"
        @change="handleChange"
        @mousedown="handleMouseDown"
      />
      <span class="toggle-slider"></span>
    </label>
    <span class="toggle-label" v-if="label">{{ label }}</span>
    <span
      v-if="validation?.$error && validation?.required?.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2 block"
    >
      {{ PropName }} is required.
    </span>
    <span
      v-else-if="
        validation?.$error &&
        validation?.requiredIf &&
        validation?.requiredIf.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2 block"
    >
      {{ validation.requiredIf.$message.replace('value', PropName) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    sectionClass: {
      type: String,
      default: 'field',
    },
    id: {
      type: String,
      default: '',
      required: false,
    },
    label: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      required: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    PropName: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preventTurnOff: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChanging: false, // Tracks if toggle is being interacted with
    };
  },
  methods: {
    handleChange(event) {
      this.isChanging = true; // Apply border during change
      const newValue = event.target.checked;
      // Only emit update if not preventing turn-off or if turning on
      if (!this.preventTurnOff || newValue) {
        this.$emit('update:modelValue', newValue);
      } else if (this.preventTurnOff && this.modelValue && !newValue) {
        // Prevent turning off by resetting the checkbox state
        event.target.checked = true;
        // Emit a custom event to notify parent (e.g., to show dialog)
        this.$emit('prevented-turn-off');
      }
      this.$emit('change', event);
    },
    handleMouseDown() {
      this.isChanging = true; // Set border on mousedown
    },
    handleClickOutside(event) {
      // Check if the click is outside the toggle container
      if (!this.$el.contains(event.target)) {
        this.isChanging = false; // Remove border when clicking outside
      }
    },
  },
  mounted() {
    // Add click event listener to the document
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // Clean up the event listener
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.toggle-container {
  display: inline-flex;
  align-items: center;
  // margin-bottom: 0.5rem;
}

.toggle-wrapper {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 32px;
  border: 2px solid transparent;
  border-radius: 24px;
  padding: 2px;
}

.toggle-wrapper.active-border {
  width: 52px;
  height: 32px;
  border: 2px solid #21211f;
  border-radius: 24px;
  padding: 2px;
}

.toggle {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid #c0c0bc;
  background: #d8d8d5;
  transition: 0.4s;
  height: 24px !important;
  width: 44px !important;
  display: flex;
  justify-content: flex-start;
}

.toggle-wrapper.active-border .toggle-slider {
  top: 2px;
  right: 2px;
  bottom: 2px;
  left: 2px;
}

.toggle-wrapper:not(.active-border) .toggle-slider {
  top: 2px;
  right: 2px;
  bottom: 2px;
  left: 2px;
}

.toggle-slider:before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  bottom: 1.5px;
  left: 2px;
  background-color: white;
  transition: 0.1s;
  border-radius: 50%;
}

.toggle:disabled + .toggle-slider:before {
  background-color: #d5d5d8;
}

.toggle:checked + .toggle-slider {
  background-color: #43a584;
  border-color: #348067;
}

.toggle:checked + .toggle-slider:before {
  transform: translateX(1.2rem);
}

// .toggle:focus + .toggle-slider {
//   outline: 2px solid #222222;
//   border: 1px solid #c0c0bc;
//   box-shadow: none;
// }

.toggle:disabled + .toggle-slider {
  background-color: #f0f0ef;
  cursor: not-allowed;
  border: 1px solid #d8d8d5;
  opacity: 0.8;
}

.toggle-label {
  margin-left: 0.5rem;
  vertical-align: middle;
  font-size: 1rem;
}

.p-error {
  color: #dc3545;
  font-size: 0.875rem;
}
</style>